import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Container,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { clientmanageService } from "../../services/clientmanageService.js";
import { toast } from "react-toastify";
import Select from "react-select";

const XeroClientSettings = () => {
  const history = useHistory();

  // ------------------------------
  // STATES
  // ------------------------------
  const [inputFields, setInputfields] = useState({
    client: "",
    sub_client: "",
    company_name: "",
    // email: "",
    password: "",
    username: "",
    xero_password: "",
    secret_key: "",
  });

  const [securityQuestions, setSecurityQuestions] = useState([]); // from DB
  const [securityAnswers, setSecurityAnswers] = useState({});
  const [disablestate, setdisablestate] = useState(false);
  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  const [subclientOptions, setSubclientOptions] = useState([]);
  const [selectedSubclients, setSelectedSubclients] = useState(null);
  const [clientsearch, setclientsearch] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // ------------------------------
  // INPUT HANDLERS
  // ------------------------------
  const inputhandler = (e) => {
    setInputfields({ ...inputFields, [e.target.name]: e.target.value });
  };

  const inputuserhandler = (e, name) => {
    let updated = { ...inputFields, [name]: e ? e.value : "" };
    setInputfields(updated);
    if (name === "sub_client") setSelectedSubclients(e);
  };

  const setclient = (e) => {
    setSelectedSubclients(null);
    setclientsearch(e);
    setInputfields({
      ...inputFields,
      client: e.value,
      sub_client: "",
      username: "",
      password: "",
      xero_password: "",
      secret_key: "",
      // email: "",
    });
    subclientList(e.label);
  };

  const handleAnswerChange = (questionId, value) => {
    setSecurityAnswers({ ...securityAnswers, [questionId]: value });
  };

  // ------------------------------
  // FETCH CLIENT, SUBCLIENT, QUESTIONS
  // ------------------------------
  useEffect(() => {
    get_unique_companieslist();
    getQuestions();
  }, []);

  const get_unique_companieslist = () => {
    clientmanageService.getuniqueclient().then((response) => {
      if (response.status === 200) {
        setUniqueCompaniesData(response.data);
      }
    });
  };

  const subclientList = (clientname = "") => {
    clientmanageService.getsubclientlist(clientname).then((response) => {
      if (response.status === 200) {
        const subclientOptions = response.data.map((res) => ({
          value: res.id,
          label: res.sub_client,
        }));
        setSubclientOptions(subclientOptions);
      } else {
        toast.error("Something went wrong!");
      }
    });
  };

  const getQuestions = () => {
    clientmanageService.getSecurityQuestions().then((response) => {
      if (response.status === 200) {
        setSecurityQuestions(response.data.data);
      }
    });
  };

  // ------------------------------
  // GET EXISTING XERO CREDENTIALS
  // ------------------------------
  const getXeroCredentials = (clientId, subClientName) => {
    if (!clientId || !subClientName) return;

    clientmanageService
      .getXeroSettings({
        client_id: clientId,
        sub_client: subClientName,
      })
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          const data = response.data.data;

          setInputfields((prev) => ({
            ...prev,
            ...data,
          }));

        if (data.questions) {
          if (typeof data.questions === "string") {
            try {
              setSecurityAnswers(JSON.parse(data.questions));
            } catch {
              setSecurityAnswers({});
            }
          } else if (typeof data.questions === "object") {
            setSecurityAnswers(data.questions);
          } else {
            setSecurityAnswers({});
          }
        }

          setIsEditMode(true);
        } else {
          setInputfields((prev) => ({
            ...prev,
            username: "",
            password: "",
            xero_password: "",
            secret_key: "",
            // email: "",
          }));
          setSecurityAnswers({});
          setIsEditMode(false);
        }
      })
      .catch(() => {
        toast.error("Error fetching credentials");
      });
  };

  // Automatically refetch credentials when both client & sub-client are selected
  useEffect(() => {
    if (inputFields.client && inputFields.sub_client) {
      getXeroCredentials(inputFields.client, inputFields.sub_client);
    }
  }, [inputFields.client, inputFields.sub_client]);

  // ------------------------------
  // SAVE DATA
  // ------------------------------
  const adddata = (e) => {
    e.preventDefault();
    setdisablestate(true);

    const payload = {
      client_id: inputFields.client,
      sub_client: inputFields.sub_client,
      // email: inputFields.email,
      password: inputFields.password,
      username: inputFields.username,
      xero_password: inputFields.xero_password,
      secret_key: inputFields.secret_key,
      questions: JSON.stringify(securityAnswers),
    };

    clientmanageService
      .saveXeroSettings(payload)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message);
          setIsEditMode(true);
          get_unique_companieslist();
          if (clientsearch) subclientList(clientsearch.label);
        } else {
          toast.error(response.data.message);
        }
        setdisablestate(false);
      })
      .catch(() => {
        toast.error("Something went wrong while saving.");
        setdisablestate(false);
      });
  };

  // ------------------------------
  // CANCEL FORM
  // ------------------------------
  const cancel_form = () => {
    document.getElementById("addclient-form").reset();
    setInputfields({
      client: "",
      sub_client: "",
      // email: "",
      password: "",
      username: "",
      xero_password: "",
      secret_key: "",
    });
    setSecurityAnswers({});
    setSelectedSubclients(null);
    setclientsearch(null);
    setIsEditMode(false);
    history.goBack();
  };

  // ------------------------------
  // RENDER
  // ------------------------------
  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <Container fluid>
        <Row className="justify-content-md-center">
          <Col lg="12" md="12">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <h3 className="mb-0">Xero Client Data Setting</h3>
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-10">
                <Form role="form" id="addclient-form" onSubmit={adddata}>
                  <FormGroup>
                    <Row>
                      {/* CLIENT */}
                      <Col lg="6" md="6">
                        <label>Client</label>
                        <Select
                          name="client"
                          options={uniquecompanieslist}
                          onChange={(e) => setclient(e)}
                          value={clientsearch}
                          placeholder="Select Client"
                        />
                      </Col>

                      {/* SUB CLIENT */}
                      <Col lg="6" md="6">
                        <label>Sub Client</label>
                        <Select
                          name="sub_client"
                          options={subclientOptions}
                          value={selectedSubclients}
                          onChange={(e) => {
                            inputuserhandler(e, "sub_client");
                            const selectedClient = clientsearch
                              ? clientsearch.value
                              : inputFields.client;
                            if (selectedClient && e?.value) {
                              getXeroCredentials(selectedClient, e.value);
                            }
                          }}
                          placeholder="Select Sub Client"
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  {/* SECURITY QUESTIONS */}
                  <FormGroup>
                    <label>Security Questions</label>
                    {securityQuestions.length > 0 ? (
                      securityQuestions.map((q) => (
                        <div key={q.id} className="mb-2">
                          <label className="form-control-label">
                            {q.name}
                          </label>
                          <Input
                            type="text"
                            placeholder="Enter your answer"
                            value={securityAnswers[q.id] || ""}
                            onChange={(e) =>
                              handleAnswerChange(q.id, e.target.value)
                            }
                          />
                        </div>
                      ))
                    ) : (
                      <p>No security questions found.</p>
                    )}
                  </FormGroup>

                  {/* EMAIL & PASSWORD */}
                  <FormGroup>
                    <Row>
                      <Col lg="6" md="6">
                        <label>Email</label>
                        <Input
                          placeholder="Enter Xero username"
                          type="text"
                          name="username"
                          value={inputFields.username}
                          onChange={inputhandler}
                        />
                      </Col>

                      <Col lg="6" md="6">
                        <label>Password</label>
                        <Input
                          placeholder="Enter Xero password"
                          type="password"
                          name="password"
                          value={inputFields.password}
                          onChange={inputhandler}
                        />
                      </Col>
                    </Row>
                  </FormGroup>

                  {/* SECRET KEY */}
                  <FormGroup>
                    <label>Secret Key</label>
                    <Input
                      placeholder="Enter secret key"
                      type="text"
                      name="secret_key"
                      value={inputFields.secret_key}
                      onChange={inputhandler}
                    />
                  </FormGroup>

                  {/* BUTTONS */}
                  <div className="col-12">
                    <Button
                      className="mt-2"
                      color="primary"
                      type="submit"
                      disabled={disablestate}
                    >
                      {disablestate
                        ? "Saving..."
                        : isEditMode
                        ? "Update"
                        : "Save"}
                    </Button>
                    <Button
                      className="mt-2 ml-2"
                      color="secondary"
                      type="button"
                      onClick={cancel_form}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default XeroClientSettings;
